import React from 'react';
export function Footer() {
  return <footer className="bg-navy-deep py-8 border-t border-gold/30 text-center px-4" data-id="element-149" data-mp="32wd2qgad7ltj">
      <div className="max-w-4xl mx-auto" data-id="element-150" data-mp="3gg0za3iktxxn">
        <p className="text-gold-light text-sm" data-id="element-151" data-mp="3gh3ng3oilm9v">
          © Brazilian Jiu-Jitsu Instructor Ready 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}